import { render } from "./app.vue?vue&type=template&id=dec1c252"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/odk/odk-ssdd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__